import { css, cx, etiColors } from '@eti/styles';
import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const inputLabelStyles = css`
  align-items: center;
  color: ${etiColors.black};
  cursor: pointer;
  display: flex;
  font-size: 0.875rem;
  font-weight: 700;
  position: relative;
`;
const styledRadioStyles = css`
  clip: rect(0 0 0 0);
  opacity: 0;
  position: absolute;
  z-index: -1;
`;
const customRadioControlStyles = isNeutral => css`
  align-items: center;
  background-color: transparent;
  background-position: center center;
  background-repeat: no-repeat;
  border: 1px solid ${etiColors.grayScale[10]};
  border-radius: 50%;
  color: ${etiColors.grayScale[5]};
  display: flex;
  flex-shrink: 0;
  height: 1.25rem;
  justify-content: center;
  left: 0;
  text-align: center;
  user-select: none;
  width: 1.25rem;

  html[dir='rtl'] & {
    left: auto;
    right: 0;
  }

  input:focus ~ & {
    border-color: ${etiColors.info.solid};
    box-shadow:
      0 0 5px rgb(53 134 209 / 50%),
      inset 0 2px 0 ${etiColors.grayScale[6]};
  }

  input:checked ~ &::after {
    animation: dotAnimation 0.1s ease-in forwards;
    background-color: ${isNeutral ? etiColors.info.solid : etiColors.confirmation.solid};
    background-color: ${etiColors.confirmation.solid};
    border-radius: 50%;
    content: '';
    display: block;
    height: 0.75rem;
    transform: scale(0.1);
    width: 0.75rem;

    @keyframes dotAnimation {
      from {
        transform: scale(0.1);
      }
      to {
        transform: scale(1);
      }
    }

    @media (min-width: 60.625em) {
      height: 0.625rem;
      width: 0.625rem;
    }
  }
`;
const RadioButton = _ref => {
  let {
    children,
    classNames = {},
    id,
    inputTestId,
    isNeutral,
    isSelected,
    labelTestId,
    name,
    onChange,
    value,
    ...rest
  } = _ref;
  const handleChange = () => {
    if (isFunction(onChange)) {
      onChange();
    }
  };
  return /*#__PURE__*/_jsxs("label", {
    className: cx('etiRadioLabel', inputLabelStyles, classNames.label),
    "data-testid": labelTestId,
    htmlFor: id,
    children: [/*#__PURE__*/_jsx("input", {
      "aria-checked": isSelected,
      checked: isSelected,
      className: cx('etiRadio', styledRadioStyles),
      "data-testid": inputTestId,
      id: id,
      name: name,
      onChange: handleChange,
      type: "radio",
      value: value !== null && value !== void 0 ? value : id,
      ...rest
    }), /*#__PURE__*/_jsx("span", {
      className: cx('etiCustomRadio', customRadioControlStyles(isNeutral), classNames.radio)
    }), children]
  });
};
RadioButton.propTypes = {
  children: PropTypes.node,
  classNames: PropTypes.shape({
    label: PropTypes.string,
    radio: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  inputTestId: PropTypes.string,
  isNeutral: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  labelTestId: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.arrayOf(PropTypes.shape({
    priceRaw: PropTypes.number,
    value: PropTypes.string
  }))])
};
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map